"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var types_1 = require("../../../types");
var Step1_1 = __importDefault(require("./Step1"));
var Step2_1 = __importDefault(require("./Step2"));
var useAmountLimitOptions_1 = require("./useAmountLimitOptions");
var useDurationLimitOptions_1 = require("./useDurationLimitOptions");
var swr_hooks_1 = require("@l2p/swr-hooks");
var SetGameLimit = function (_a) {
    var type = _a.type, onClose = _a.onClose;
    var _b = (0, react_1.useState)(0), step = _b[0], setStep = _b[1];
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    var amountLimitsOptions = (0, useAmountLimitOptions_1.useAmountLimitOptions)();
    var durationLimitsOptions = (0, useDurationLimitOptions_1.useDurationLimitOptions)();
    var _c = (0, react_1.useState)(5000), limitAmount = _c[0], setLimitAmount = _c[1];
    var _d = (0, react_1.useState)(0), limitDuration = _d[0], setLimitDuration = _d[1];
    var _e = (0, swr_hooks_1.useSetBetLimit)({
        successAction: onClose,
    }), setBetLimit = _e.setBetLimit, isSubmittingBetLimit = _e.isSubmitting;
    var _f = (0, swr_hooks_1.useSetLossLimit)({
        successAction: onClose,
    }), setLossLimit = _f.setLossLimit, isSubmittingLossLimit = _f.isSubmitting;
    var _g = (0, swr_hooks_1.useSetDepositLimit)({
        successAction: onClose,
    }), setDepositLimit = _g.setDepositLimit, isSubmittingDepositLimit = _g.isSubmitting;
    var onChangeLimitAmountHandler = (0, react_1.useCallback)(function (value) {
        setLimitAmount(value);
    }, []);
    var onChangeLimitDurationHandler = (0, react_1.useCallback)(function (value) {
        if (typeof value === 'number')
            setLimitDuration(value);
    }, []);
    var setNextStep = (0, react_1.useCallback)(function () {
        setStep(1);
    }, []);
    var setPrevStep = (0, react_1.useCallback)(function () {
        setStep(0);
    }, []);
    var confirmSetLimit = (0, react_1.useCallback)(function () {
        if (type === types_1.LimitType.DEPOSIT)
            setDepositLimit({
                maxValue: limitAmount,
                period: useDurationLimitOptions_1.DURATION_LIMIT_OPTIONS[limitDuration],
            });
        if (type === types_1.LimitType.BET)
            setBetLimit({
                maxValue: limitAmount,
                period: useDurationLimitOptions_1.DURATION_LIMIT_OPTIONS[limitDuration],
            });
        if (type === types_1.LimitType.LOSS)
            setLossLimit({
                maxValue: limitAmount,
                period: useDurationLimitOptions_1.DURATION_LIMIT_OPTIONS[limitDuration],
            });
    }, [
        type,
        setDepositLimit,
        limitAmount,
        limitDuration,
        setBetLimit,
        setLossLimit,
    ]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "525px", height: "auto", padding: "0", onClose: onClose, showClose: true }, step === 0 ? (react_1.default.createElement(Step1_1.default, { type: type, setNextStep: setNextStep, limitDuration: limitDuration, limitAmount: limitAmount, onChangeLimitDurationHandler: onChangeLimitDurationHandler, onChangeLimitAmountHandler: onChangeLimitAmountHandler, amountLimitsOptions: amountLimitsOptions, durationLimitsOptions: durationLimitsOptions })) : (react_1.default.createElement(Step2_1.default, { setPrevStep: setPrevStep, type: type, limitAmount: formatCurrency(limitAmount), limitDuration: "".concat(durationLimitsOptions[limitDuration] || ''), confirmSetLimit: confirmSetLimit, isSubmitting: isSubmittingBetLimit ||
            isSubmittingDepositLimit ||
            isSubmittingLossLimit }))));
};
exports.default = SetGameLimit;
